<div class="app-layout">
  <div class="sidebar-wrapper">
    <app-navigation></app-navigation>
  </div>

  <main class="content-wrapper">
    <av-header></av-header>
    <div class="main-content">
      <router-outlet></router-outlet>
    </div>
    <av-footer></av-footer>
  </main>
</div>
